import * as React from 'react';
import { Select } from '@blueprintjs/select';
import { Category } from '../models/category';
import { Button, MenuItem } from '@blueprintjs/core';
import DataStore from '../data_store';
import { withTranslation, WithTranslation } from 'react-i18next';

const BlueprintSelect = Select.ofType<Category>();

export interface Props extends WithTranslation {
  activeItem?: Category;
  onSelect: (category: Category) => void;
  disabled?: boolean;
}

export function CategoryParentSelect({ activeItem, onSelect, disabled, i18n, t }: Props) {
  const [categories, setCategories] = React.useState<Category[]>([]);

  React.useEffect(() => {
    setCategories(DataStore.parentCategories());
  }, []);

  const itemRenderer = (item: Category, options: any) => {
    const name = i18n.language === 'fi' ? item.name_fi : item.name_en;
    return (
      <MenuItem
        key={item.id}
        text={name}
        onClick={options.handleClick}
        active={options.modifiers.active}
      />
    );
  };

  const filterItem = (query: string, item: Category) => {
    const name = i18n.language === 'fi' ? item.name_fi : item.name_en;
    return name.toLowerCase().includes(query.toLowerCase());
  };

  const buttonText = activeItem?.exists
    ? (i18n.language === 'fi' ? activeItem.name_fi : activeItem.name_en)
    : t('type');

  return (
    <BlueprintSelect
      filterable={true}
      disabled={disabled}
      items={categories}
      activeItem={activeItem}
      itemRenderer={itemRenderer}
      itemPredicate={filterItem}
      onItemSelect={onSelect}
      popoverProps={{ minimal: true }}
    >
      <Button
        disabled={disabled}
        text={buttonText}
        rightIcon="chevron-down"
        fill={true}
      />
    </BlueprintSelect>
  );
}

export default withTranslation()(CategoryParentSelect);
